export default __webpack_public_path__ + "static/toolbar-selector-edit-light-mode-38e788b710c20425852ab80755a1fcea.mp4";